<template>

</template>

<script>
export default {
    name: 'PricingPage',
    data() {
        return {
            merchantId: '10040492',
            merchantKey: 'ny33hkarlf0k9',
            amount: 1000,
        };
    },
    methods: {
        redirectToPayFast() {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://sandbox.payfast.co.za/eng/process'; // no leading space/tab
            const returnUrlWithAmount = `${window.location.origin}/payfast?amount=${plan.amount}`;
            form.innerHTML = `
          <input type="hidden" name="merchant_id" value="${this.merchantId}" />
          <input type="hidden" name="merchant_key" value="${this.merchantKey}" />
          <input type="hidden" name="amount" value="${this.amount}" />
          <input type="hidden" name="item_name" value="Purchase ${this.amount} credits" />
          <input type="hidden" name="return_url" value="${returnUrlWithAmount}" />
          <input type="hidden" name="cancel_url" value="${window.location.origin}/payfast" />
        `;
            document.body.appendChild(form);
            form.submit();
        }
    }
};
</script>

<style scoped>
.pricing-page {
    width: 100%;
    min-height: 100vh;
    padding: 4rem 2rem;
}

.pricing-header-row {
    margin-bottom: 2rem;
    margin-top: 10%;
}

.pricing-header {
    font-size: 2.5rem;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
}

.pricing-cards-row {
    gap: 1rem;
}

.plan-card {
    border-radius: 20px;
    overflow: visible;
    background-color: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding-top: 1.5rem;
    position: relative;
}

.plan-header {
    height: 60px;
    margin-top: -30px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.plan-header::after {
    content: "";
    width: 60px;
    height: 20px;
    background-color: inherit;
    position: absolute;
    bottom: -10px;
    left: calc(50% - 30px);
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
}

.plan-title {
    color: #ffffff;
    font-size: 1.125rem;
    font-weight: 600;
    z-index: 1;
}

.plan-price {
    margin-top: 1.5rem;
    text-align: center;
}

.price-text {
    font-size: 1.75rem;
    font-weight: 700;
    color: #333333;
}

.plan-description {
    font-size: 0.875rem;
    color: #666666;
    text-align: center;
    margin: 0.5rem 1rem;
}

.plan-features {
    list-style: none;
    padding: 0;
    margin: 1rem 0;
    text-align: left;
    margin-left: 1.5rem;
}

.plan-features li {
    margin: 0.5rem 0;
    position: relative;
}

.plan-features li::before {
    content: "•";
    position: absolute;
    left: -1rem;
    color: #333333;
}

.plan-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding-bottom: 1.5rem;
}

.plan-btn {
    width: 100%;
    max-width: 180px;
    color: #ffffff !important;
    background-color: inherit !important;
    font-weight: 600;
}
</style>